import {
  MyAccountApi, IdentityResponse, // eslint-disable-line no-unused-vars
} from '@clients/myProfile'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-profile'

export default class ExtendedMyAccountApi extends MyAccountApi {
  getIdentity (options?: any): AxiosPromise<IdentityResponse> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getIdentity('', '', optionsParam)
  }
}
